import { render } from "./office-intro.vue?vue&type=template&id=05103cca&scoped=true"
import script from "./office-intro.vue?vue&type=script&lang=js"
export * from "./office-intro.vue?vue&type=script&lang=js"

import "./office-intro.vue?vue&type=style&index=0&id=05103cca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05103cca"]])

export default __exports__